import { isoZ, z } from 'my-zod'

export const JobFunctionEnum = z.enum([
  'Engineering',
  'Global Product Safety & Quality',
  'Government & Defense',
  'Marketing',
  'Sales',
  'Other – not listed'
])
export const JobFunctions = JobFunctionEnum.Values
export const JobFunctionList = Object.values(JobFunctionEnum.Values)

export const ProductGroupEnum = z.enum([
  'ATV - adult',
  'Boat',
  'GEM',
  'Motorcycle',
  'ORV Youth',
  'SxS - adult',
  'Slingshot',
  'Snowmobile',
  'Snowmobile Youth',
  'Timbersled',
  'Trailers for Polaris Owned Units or Cargo'
])
export const ProductGroups = ProductGroupEnum.Values
export const ProductGroupList = Object.values(ProductGroupEnum.Values)

export const ehsPolarisEmployeeModel = z.object({
  id: z.string(),
  employeeNumber: z.string(),
  buildingLocation: z.number(),
  customerId: z.string(),
  jobFunction: JobFunctionEnum.nullable(),
  costCenterId: z.number().nullable(),
  productGroups: z.array(ProductGroupEnum),
  createdDate: isoZ.instant().nullable(),
  serverLastModifiedDate: isoZ.instant().nullable(),
  managersEmail: z.string().email().nullable()
})
export type ehsPolarisEmployeeModel = z.infer<typeof ehsPolarisEmployeeModel>
